import styled from 'styled-components';
import {getColor} from '@/styles/ThemeConfig';
import Image from 'next/image';
import {useEffect, useState} from "react";
import {breakpoints} from "@/styles/sizes";

// Styled Components
const SectionContainer = styled.div`
  background-color: ${getColor('gold')};
  color: white;
  padding: 50px;
  text-align: center;
    height: fit-content;
    @media only screen and (${breakpoints.mobile}) {
        padding: 20px;
    }
`;

const Title = styled.h2`
  font-size: 24px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: bold;
  padding: 10px 0 20px;
  text-transform: uppercase;
  text-align: center;
`;

const Description = styled.p`
  margin-bottom: 30px;
`;

const LogoWrapper = styled.div`
  text-align: center;
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 350px;
  object-fit: cover;
`;

// Main Component
export default function TourWhySection({ title, description, image, footerData, ...rest }) {
    const [isClient, setIsClient] = useState(false);

    // Check if the component is rendering on the client
    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        (title &&
        description &&
        image) ?
        <SectionContainer {...rest}>
            <LogoWrapper>
                <Image
                    width={56}
                    height={56}
                    src={footerData?.logo?.url}
                    alt={footerData?.logo?.alt ?? footerData?.logo?.name ?? 'Logo'}
                    style={{ width: '56px', height: 'auto' }}
                />
            </LogoWrapper>

            <Title>{title}</Title>
            {isClient && <Description dangerouslySetInnerHTML={{__html: description}}/>}

            {
                image?.url &&
                <StyledImage
                    src={image?.url}
                    alt={image?.alt ?? image?.name}
                    width={520}
                    height={300}
                />
            }

        </SectionContainer>
            :
            <div/>
    );
}
